module.exports = __webpack_public_path__ + "static/media/00_360.1ffa1d27.jpeg";